/* eslint-disable max-len */
import {inputType} from '../../interface/inputType';

import {exporteEntityInfokeys, installationDetailskeys, productClassificationkeys, multiInstallationAndMultiProductMappingkeys, productionDataPerProductkeys, rawMaterialInputDatakeys, fuelConsumptionkeys, electricityAndHeatDatakeys, processEmissionsCalcinationkeys, combustionEmissionsKilnFuelskeys, otherProcessEmissionskeys, purchasedElectricityKeys, captiveElectricityKeys, heatSteamConsumptionKeys, clinkerUsedAsPrecursorInCementKeys, precursorInputKeys, methodologySelectionKeys, dataQualityLevelsKeys, thirdPartyVerificationKeys, productLevelEmissionSummaryKeys, exportBatchEmissionAssignmentKeys, documentAttachmentsKeys} from './cbamQuestionskeys';


// section 1

export const cbamSection1ExporterAndInstallationProfileTabQuestions = [
    {
      key: '1',
      items: [
        {
          question: '1.1.1 Exporter legal entity name',
          tooltip:'Registered legal name of the exporting organisation (as per trade license / company registry).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.2 Registered trade name (if different)',
          tooltip:'Brand or trade name used commercially, if different from legal name.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.3 Country of registration of exporter',
          tooltip:'Jurisdiction where the exporter is legally incorporated.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.4 Country of manufacture',
          tooltip:'Country where the cement/clinker is physically produced.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.5 Legal entity registration number',
          tooltip:'Company registration / CIN / ROC number.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.6 Tax / VAT / GST ID',
          tooltip:'National indirect tax ID (VAT/GST/etc.).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.7 LEI (Legal Entity Identifier)',
          tooltip:'LEI code if the entity has one.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.8 Entity type',
          tooltip:'Legal form of the exporter.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.9 Part of a parent corporate group?',
          tooltip:'Whether exporter belongs to a larger group.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.10 Parent group name',
          tooltip:'Legal name of ultimate or intermediate parent group.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.11 Parent group country',
          tooltip:'Country where parent group is registered.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_11,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.12 Primary CBAM contact name',
          tooltip:'Person responsible for CBAM emissions communication.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_12,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.13 Primary CBAM contact designation',
          tooltip:'Job title / role of CBAM contact.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_13,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.14 Primary CBAM contact email',
          tooltip:'Official email for CBAM communication.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_14,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.15 Primary CBAM contact phone',
          tooltip:'Phone number (with country code).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_15,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.16 Alternate CBAM contact name',
          tooltip:'Backup person for CBAM communication.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_16,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.17 Alternate CBAM contact email',
          tooltip:'Email of alternate CBAM contact.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_17,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.18 Preferred correspondence language',
          tooltip:'Language for CBAM-related communication.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_18,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.19 Time zone of head office',
          tooltip:'Time zone of exporter\'s main office.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_19,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.1.20 Primary EU customer(s) / importer(s)',
          tooltip:'Names of key EU importers of this cement/clinker.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exporteEntityInfokeys.EXPORTER_ENTITY_INFO_QUESTION_20,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection1InstallationDetailsTabQuestions = [
    {
      key: '1',
      items: [
        {
          question: '1.2.1 Internal installation code',
          tooltip:'Unique internal ID for the installation in the companys system.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.2 Installation CBAM ID (if assigned)',
          tooltip:'CBAM installation identifier once registered in EU CBAM registry.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.3 Installation name',
          tooltip:'Name used internally / externally for the plant.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.4 Registered installation address',
          tooltip:'Legal registered address of the installation (as per permits).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.5 Manufacturing site address (if different)',
          tooltip:'Physical production location if not the same as registered address.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.6 Country of installation',
          tooltip:'Country where the plant physically operates.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.7 GPS latitude',
          tooltip:'Latitude coordinate in decimal degrees.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.8 GPS longitude',
          tooltip:'Longitude coordinate in decimal degrees.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.9 Installation type',
          tooltip:'High-level classification of the plant.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.10 Does installation operate kilns?',
          tooltip:'Indicates if clinker is produced at this site.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.11 Number of kilns in operation',
          tooltip:'Count of active clinker kilns.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_11,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.12 Primary kiln type',
          tooltip:'Dominant technology used for clinker production.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_12,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.13 Kiln type "Other" description',
          tooltip:'Free-text description if kiln type is not standard.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_13,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.14 Main kiln fuel firing system',
          tooltip:'Basic firing configuration (e.g., main burner, calciner, etc.).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_14,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.15 Waste Heat Recovery (WHR) system installed?',
          tooltip:'Indicates presence of WHR-based power generation.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_15,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.16 Days of operation during reporting period',
          tooltip:'Number of calendar days the plant operated.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_16,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.2.17 Outsourced manufacturing processes?',
          tooltip:'Whether key processes (grinding, packing) are outsourced.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: installationDetailskeys.INSTALLATION_DETAILS_QUESTION_17,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection1ProductClassificationTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '1.3.1 Product line / internal product code',
          tooltip:'Companys internal product identifier.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.2 CN code',
          tooltip:'8-digit CN code for the product to be exported.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.3 Cement type / designation',
          tooltip:'Commercial/standard type of cement.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.4 Cement type "Other" description',
          tooltip:'Specify cement type if "Other" selected.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.5 Strength class',
          tooltip:'Mechanical strength classification as per standard.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.6 Norm / standard applicable',
          tooltip:'Technical standard used for product compliance.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.7 Physical form',
          tooltip:'How the product is exported.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.8 Exported to EU?',
          tooltip:'Whether this product is (or will be) exported to EU.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.9 Clinker factor for this product (%)',
          tooltip:'Mass percentage of clinker in the cement type.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.10 Additives used in product',
          tooltip:'Additives / SCMs included in product.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.11 Additive "Other" description',
          tooltip:'Describe any other additive not listed.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_11,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.12 Moisture content of product (%)',
          tooltip:'Average moisture content of finished cement/clinker.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_12,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.13 Annual production volume of this product (tons)',
          tooltip:'Total quantity produced in reporting period.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_13,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.3.14 % of this product exported to EU (%)',
          tooltip:'Share of production destined to EU markets.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productClassificationkeys.PRODUCT_CLASSIFICATION_QUESTION_14,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection1MultiInstallationAndMultiProductMappingTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '1.4.1 Does exporter have more than one installation?',
          tooltip:'Whether multiple plants contribute to export portfolio.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: multiInstallationAndMultiProductMappingkeys.MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.4.2 Number of installations',
          tooltip:'Count of installations under this exporter relevant for CBAM.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: multiInstallationAndMultiProductMappingkeys.MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.4.3 Installation code (per site)',
          tooltip:'Installation IDs contributing to CBAM products.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: multiInstallationAndMultiProductMappingkeys.MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.4.4 Installation country (per site)',
          tooltip:'Country of each installation in the multi-site setup.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: multiInstallationAndMultiProductMappingkeys.MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.4.5 Main CN codes manufactured at each installation',
          tooltip:'CN code portfolio per installation.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: multiInstallationAndMultiProductMappingkeys.MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.4.6 How is CBAM data managed?',
          tooltip:'Governance of CBAM data management.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: multiInstallationAndMultiProductMappingkeys.MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.4.7 Source system (ERP / MIS) for production & emissions data',
          tooltip:'Main digital source of production & emissions data.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: multiInstallationAndMultiProductMappingkeys.MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.4.8 ERP / system name if "Other"',
          tooltip:'Name of custom or other ERP/MIS system.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: multiInstallationAndMultiProductMappingkeys.MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '1.4.9 Central CBAM data repository exists?',
          tooltip:'Whether there is a central database for all CBAM data.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: multiInstallationAndMultiProductMappingkeys.MULTI_INSTALLATION_AND_MULTI_PRODUCT_MAPPING_QUESTION_9,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  // section 2 

  export const cbamSection2ProductionDataPerProductTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '2.1.1 Reporting period start date',
          tooltip:'Start date for all activity & emission calculations.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.2 Reporting period end date',
          tooltip:'End date for all activity & emission calculations.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.3 Production period type',
          tooltip:'Type of reporting under CBAM phase.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.4 Does this installation produce clinker?',
          tooltip:'Determines applicability of calcination & fuel questions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.5 Total clinker production (tons)',
          tooltip:'Total clinker output for the reporting period.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.6 Total cement production (tons)',
          tooltip:'Total cement output from all cement mills.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.7 Monthly production tracking available?',
          tooltip:'Whether production is tracked monthly.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.8 Monthly clinker production table attached?',
          tooltip:'Indicates if separate detailed monthly breakdown is uploaded.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.9 Total internal clinker used in cement (tons)',
          tooltip:'Amount of clinker consumed by cement mills from internal kilns.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.10 Total external clinker purchased (tons)',
          tooltip:'External clinker purchased for cement production.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.11 Country of origin of external clinker',
          tooltip:'Country from which clinker was purchased.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_11,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.1.12 Is any subprocess outsourced?',
          tooltip:'Determines if external activity contributes to emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productionDataPerProductkeys.PRODUCTION_DATA_PER_PRODUCT_QUESTION_12,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection2RawMaterialInputDataTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '2.2.1 Total raw meal consumption (tons)',
          tooltip:'Total mass of raw meal fed into the kiln.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.2 CaCO3 content (%)',
          tooltip:'Average CaCO3 concentration of raw meal (material chemistry).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.3 MgCO3 content (%)',
          tooltip:'Magnesium carbonate portion (optional).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.4 LOI of raw meal (%)',
          tooltip:'Loss-on-ignition parameter.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.5 Gypsum consumption (tons)',
          tooltip:'Total gypsum used in cement grinding.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.6 Additives used in cement',
          tooltip:'SCM/additives used in cement.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.7 Total additives consumption (tons)',
          tooltip:'Total SCM/additives consumed during reporting period.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.8 Additive "Other" description',
          tooltip:'Used if a custom SCM/additive is applied.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.9 Raw meal LSF (Lime Saturation Factor)',
          tooltip:'Quality parameter for kiln feed.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.10 Raw meal SM (Silica Modulus)',
          tooltip:'Kiln feed composition ratio.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.2.11 Raw meal AM (Alumina Modulus)',
          tooltip:'Kiln feed composition ratio.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: rawMaterialInputDatakeys.RAW_MATERIAL_INPUT_DATA_QUESTION_11,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection2FuelConsumptionTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '2.3.1 Are fossil fuels used?',
          tooltip:'Determines presence of combustion emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: fuelConsumptionkeys.FUEL_CONSUMPTION_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.3.2 Fossil fuel types',
          tooltip:'Types of fossil fuels burned.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: fuelConsumptionkeys.FUEL_CONSUMPTION_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.3.3 Fuel consumption (per type)',
          tooltip:'Quantity consumed of each fossil fuel.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: fuelConsumptionkeys.FUEL_CONSUMPTION_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.3.4 Net calorific value (per fuel)',
          tooltip:'NCV of fossil fuels.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: fuelConsumptionkeys.FUEL_CONSUMPTION_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.3.5 NCV source',
          tooltip:'Origin of NCV data.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: fuelConsumptionkeys.FUEL_CONSUMPTION_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.3.6 Emission factor (tCO2/TJ)',
          tooltip:'EF used for CO2 emission calculation.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: fuelConsumptionkeys.FUEL_CONSUMPTION_QUESTION_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.3.7 Emission factor source',
          tooltip:'Data source for EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: fuelConsumptionkeys.FUEL_CONSUMPTION_QUESTION_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.3.8 Oxidation factor',
          tooltip:'Carbon oxidation efficiency of fuel.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: fuelConsumptionkeys.FUEL_CONSUMPTION_QUESTION_8,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection2ElectricityAndHeatDataTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '2.4.1 Does installation purchase electricity?',
          tooltip:'Determines indirect emissions scope.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: electricityAndHeatDatakeys.ELECTRICITY_AND_HEAT_DATA_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.4.2 Total grid electricity purchased (kWh)',
          tooltip:'Total grid power imported.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: electricityAndHeatDatakeys.ELECTRICITY_AND_HEAT_DATA_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.4.3 Grid emission factor source',
          tooltip:'Source for EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: electricityAndHeatDatakeys.ELECTRICITY_AND_HEAT_DATA_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.4.4 Grid electricity EF (tCO2/MWh)',
          tooltip:'Emission factor applied.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: electricityAndHeatDatakeys.ELECTRICITY_AND_HEAT_DATA_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.4.5 Market-based or location-based?',
          tooltip:'EF methodology.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: electricityAndHeatDatakeys.ELECTRICITY_AND_HEAT_DATA_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '2.4.6 Does supplier-specific EF meet CBAM criteria?',
          tooltip:'Validity of supplier EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: electricityAndHeatDatakeys.ELECTRICITY_AND_HEAT_DATA_QUESTION_6,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  // section 3

  export const cbamSection3ProcessEmissionsCalcinationTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '3.1.1 Does the installation produce clinker?',
          tooltip:'Determines whether calcination emissions apply.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.1.2 Total raw meal input to kiln (tons)',
          tooltip:'Total raw meal fed into kiln system during the reporting period.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.1.3 Total clinker output (tons)',
          tooltip:'Total hot clinker produced from the kiln line.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.1.4 Average CaCO3 content (%)',
          tooltip:'Used for CO2 from CaCO3 decomposition (Annex IV formula).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.1.5 Average MgCO3 content (%)',
          tooltip:'Optional but improves accuracy of process CO₂ calc.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.1.6 Loss on Ignition (LOI) of raw meal (%)',
          tooltip:'Helps validate carbonate decomposition.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.1.7 Process emission factor (tCO2/ton clinker)',
          tooltip:'EF used for calcination emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.1.8 Process emission factor source',
          tooltip:'Defines whether EF is actual measured or default.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.1.9 Justification for default EF',
          tooltip:'Reason for using default instead of measured EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.1.10 Total process CO2 emissions (calcination)',
          tooltip:'Auto-calculated using clinker × EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: processEmissionsCalcinationkeys.PROCESS_EMISSIONS_CALCINATION_QUESTION_10,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection3CombustionEmissionsKilnFuelsTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '3.2.1 Are fossil fuels used in kiln/CPP?',
          tooltip:'Determines whether combustion CO₂ applies.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: combustionEmissionsKilnFuelskeys.COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.2.2 Fossil fuel types used',
          tooltip:'Select all fossil fuels used for burning clinker or CPP.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: combustionEmissionsKilnFuelskeys.COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.2.3 Fuel consumption (physical units)',
          tooltip:'Quantity consumed for each selected fuel type.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: combustionEmissionsKilnFuelskeys.COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.2.4 Net Calorific Value (NCV)',
          tooltip:'NCV for each fossil fuel.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: combustionEmissionsKilnFuelskeys.COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.2.5 NCV source',
          tooltip:'Defines how NCV was obtained.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: combustionEmissionsKilnFuelskeys.COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.2.6 Emission factor (tCO₂/TJ)',
          tooltip:'EF used for fuel combustion.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: combustionEmissionsKilnFuelskeys.COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.2.7 Emission factor source',
          tooltip:'EF origin.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: combustionEmissionsKilnFuelskeys.COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.2.8 Oxidation factor',
          tooltip:'Determines % carbon oxidised during burning (IPCC).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: combustionEmissionsKilnFuelskeys.COMBUSTION_EMISSIONS_KILN_FUELS_QUESTION_8,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection3OtherProcessEmissionsTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '3.3.1 Kiln dust (CKD) generated (tons)',
          tooltip:'Total CKD or bypass dust generated.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: otherProcessEmissionskeys.OTHER_PROCESS_EMISSIONS_QUESTION_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.3.2 CKD recycled internally (%)',
          tooltip:'Portion of CKD reused back into kiln/raw meal.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: otherProcessEmissionskeys.OTHER_PROCESS_EMISSIONS_QUESTION_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.3.3 CKD disposed (%)',
          tooltip:'Portion of CKD disposed externally.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: otherProcessEmissionskeys.OTHER_PROCESS_EMISSIONS_QUESTION_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.3.4 Are CKD emissions included in process CO₂?',
          tooltip:'Clarifies whether calcination CO₂ from CKD is counted.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: otherProcessEmissionskeys.OTHER_PROCESS_EMISSIONS_QUESTION_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.3.5 Additional process emissions (if any)',
          tooltip:'Non-standard process CO2 emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: otherProcessEmissionskeys.OTHER_PROCESS_EMISSIONS_QUESTION_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '3.3.6 Evidence for CKD measurement',
          tooltip:'Supporting document for CKD quantities.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: otherProcessEmissionskeys.OTHER_PROCESS_EMISSIONS_QUESTION_6,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  // section 4

  export const cbamSection4PurchasedElectricityTabQuestions =[
    {
      key: '1',
      items: [
        {
          question: '4.1.1 Does the installation purchase grid electricity?',
          tooltip:'Determines applicability of indirect electricity emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.2 Total purchased electricity (kWh)',
          tooltip:'Total grid electricity imported during reporting period.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.3 Metering method used',
          tooltip:'How electricity consumption is measured.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.4 Upload electricity bill / statement',
          tooltip:'Billing or evidence for electricity consumption.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.5 Grid emission factor (tCO2/MWh)',
          tooltip:'EF applied for purchased electricity.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.6 Grid emission factor source',
          tooltip:'Source for electricity EF (Annex IV).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.7 Does supplier-specific EF meet CBAM conditions?',
          tooltip:'Validate supplier\'s EF eligibility.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.8 Market-based or location-based factor?',
          tooltip:'Type of EF used.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.9 Renewable electricity certificates used?',
          tooltip:'Whether GO/REC/I-REC is applied.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.10 Type of certificate',
          tooltip:'Type of renewable certificate applied.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.11 MWh covered by renewable certificates',
          tooltip:'Electricity amount backed by certificates.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_11,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.12 Upload certificates',
          tooltip:'Evidence of GO / REC / I-REC.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_12,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.13 Certificate registry / issuing body',
          tooltip:'Identifies certificate authority.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_13,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.14 Certificate validity period',
          tooltip:'Validity timeframe of certificates.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_14,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.1.15 Net purchased electricity (after CPP export adjustment)',
          tooltip:'Auto-calculated if CPP export exists.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: purchasedElectricityKeys.PURCHASED_ELECTRICITY_QUESTION_4_1_15,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection4CaptiveElectricityTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '4.2.1 Is on-site/captive electricity generated?',
          tooltip:'Identifies CPP / WHR applicability.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.2.2 Captive generation type',
          tooltip:'Type of generator powering the site.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.2.3 Captive electricity generated (kWh)',
          tooltip:'Total electricity generated by CPP/WHR.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.2.4 Captive electricity consumed in production (kWh)',
          tooltip:'CPP electricity used internally.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.2.5 Electricity exported to grid (kWh)',
          tooltip:'Exported CPP electricity.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.2.6 Is exported electricity excluded from CBAM?',
          tooltip:'CBAM only considers net imported energy.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.2.7 CPP fuel type(s)',
          tooltip:'Fuel used in CPP.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.2.8 CPP emission factor (tCO2/MWh)',
          tooltip:'EF used for CPP electricity.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.2.9 CPP EF source',
          tooltip:'EF derivation source.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.2.10 Upload CPP emission factor evidence',
          tooltip:'Lab report or supplier certificate.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: captiveElectricityKeys.CAPTIVE_ELECTRICITY_QUESTION_4_2_10,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection4HeatSteamConsumptionTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '4.3.1 Does the installation consume purchased heat/steam?',
          tooltip:'Determines if heat energy is included in indirect emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: heatSteamConsumptionKeys.HEAT_STEAM_QUESTION_4_3_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.3.2 Heat / steam quantity consumed',
          tooltip:'Total quantity of purchased heat or steam.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: heatSteamConsumptionKeys.HEAT_STEAM_QUESTION_4_3_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.3.3 Source of purchased heat/steam',
          tooltip:'Supplier or system providing heat energy.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: heatSteamConsumptionKeys.HEAT_STEAM_QUESTION_4_3_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.3.4 Heat/Steam emission factor (tCO2/MWh steam)',
          tooltip:'EF for thermal energy imported.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: heatSteamConsumptionKeys.HEAT_STEAM_QUESTION_4_3_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.3.5 Emission factor source',
          tooltip:'Origin of thermal EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: heatSteamConsumptionKeys.HEAT_STEAM_QUESTION_4_3_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '4.3.6 Evidence upload',
          tooltip:'Supporting document for heat/steam source or EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: heatSteamConsumptionKeys.HEAT_STEAM_QUESTION_4_3_6,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  // section 5

  export const cbamSection5ClinkerUsedAsPrecursorInCementTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '5.1.1 Does the installation use its own (internal) clinker?',
          tooltip:'Determines if internal clinker has to be treated as a precursor under Annex IV.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.1.2 Quantity of internal clinker used in cement (tons)',
          tooltip:'Total clinker produced and consumed internally for cement grinding.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.1.3 Internal clinker allocated to CBAM goods (tons)',
          tooltip:'Portion of internal clinker specifically used for CBAM-bound cement.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.1.4 Emission factor for internal clinker (tCO2/ton)',
          tooltip:'EF of internally produced clinker.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.1.5 How was clinker EF calculated?',
          tooltip:'Method used for internal clinker EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.1.6 Upload internal clinker EF calculation sheet',
          tooltip:'Supporting file showing EF derivation.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.1.7 Was CKD included in internal clinker EF?',
          tooltip:'Ensures CKD consistency between Section 3 & 5.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.1.8 Moisture correction applied?',
          tooltip:'Indicates if clinker moisture adjustments are applied.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.1.9 Clinker allocation method to products',
          tooltip:'How clinker is allocated to cement products.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.1.10 Upload clinker-to-product allocation sheet',
          tooltip:'BOM / recipe evidence.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: clinkerUsedAsPrecursorInCementKeys.CLINKER_USED_AS_PRECURSOR_IN_CEMENT_QUESTION_5_1_10,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection5PrecursorInputTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '5.2.1 Does installation use external (purchased) precursors?',
          tooltip:'Determines if precursor EF must be assigned.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.2 Type(s) of external precursors used',
          tooltip:'Any precursor that contains embedded emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.3 Precursor name (one per row)',
          tooltip:'Name as used in plant production/ERP.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.4 CN code of precursor',
          tooltip:'Harmonized code for imported precursor.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.5 Supplier name',
          tooltip:'Company supplying the precursor.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.6 Supplier country',
          tooltip:'Origin country of precursor.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.7 Quantity of precursor used (tons)',
          tooltip:'Total mass of precursor used in cement production.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.8 Share of precursor allocated to CBAM products (%)',
          tooltip:'Portion used in EU-bound cement.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.9 Emission factor of precursor (tCO₂/ton)',
          tooltip:'EF provided by supplier or default value.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.10 EF source',
          tooltip:'Source of precursor EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.11 Supplier EF meets CBAM rules?',
          tooltip:'If supplier EF qualifies under CBAM Annex V.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_11,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.12 Upload EF declaration from supplier',
          tooltip:'File supporting the EF claim.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_12,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.13 Transport emissions included?',
          tooltip:'Whether EF includes embedded transport emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_13,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.14 Was moisture correction applied?',
          tooltip:'Precursor moisture adjustment.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_14,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.15 Upload precursor purchase invoices',
          tooltip:'Evidence of origin + quantity.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_15,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.16 Additional precursors not listed?',
          tooltip:'For any unique SCM.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_16,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.17 Additional precursor description',
          tooltip:'Free-text for unique precursor.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_17,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.18 Additional precursor EF',
          tooltip:'EF of custom precursor.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_18,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.19 External precursor verification level',
          tooltip:'Data quality level for precursor EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_19,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '5.2.20 Upload full precursor emissions calculation sheet',
          tooltip:'Mandatory for all non-default EF.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: precursorInputKeys.PRECURSOR_INPUT_QUESTION_5_2_20,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  // section 6

  export const cbamSection6MethodologySelectionTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '6.1.1 Which emission calculation method is used?',
          tooltip:'Method applied to calculate embedded emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: methodologySelectionKeys.METHODOLOGY_SELECTION_QUESTION_6_1_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.1.2 If partially actual, which parts use default?',
          tooltip:'Identify which emission components use default values.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: methodologySelectionKeys.METHODOLOGY_SELECTION_QUESTION_6_1_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.1.3 Provide justification for using default values',
          tooltip:'Reason why actual measurement was not possible.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: methodologySelectionKeys.METHODOLOGY_SELECTION_QUESTION_6_1_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.1.4 Was an ETS-based EF used?',
          tooltip:'Whether the installation uses ETS benchmarking.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: methodologySelectionKeys.METHODOLOGY_SELECTION_QUESTION_6_1_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.1.5 ETS region / system referenced',
          tooltip:'ETS jurisdiction used.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: methodologySelectionKeys.METHODOLOGY_SELECTION_QUESTION_6_1_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.1.6 ETS benchmark year',
          tooltip:'Year of ETS benchmark used.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: methodologySelectionKeys.METHODOLOGY_SELECTION_QUESTION_6_1_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.1.7 Upload ETS calculation document',
          tooltip:'ETS verification or benchmark table.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: methodologySelectionKeys.METHODOLOGY_SELECTION_QUESTION_6_1_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.1.8 Were any approximation methods used?',
          tooltip:'Whether any estimations/approximations were done.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: methodologySelectionKeys.METHODOLOGY_SELECTION_QUESTION_6_1_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.1.9 Upload methodology description',
          tooltip:'Full methodological approach used for emission computation.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: methodologySelectionKeys.METHODOLOGY_SELECTION_QUESTION_6_1_9,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection6DataQualityLevelsTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '6.2.1 Select data quality level for this product/report',
          tooltip:'Official data confidence level per Annex V.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.2 Data completeness (%)',
          tooltip:'% completeness of emission data relative to full boundary.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.3 Data accuracy confidence (%)',
          tooltip:'Confidence level in measurement system.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.4 How were uncertainties evaluated?',
          tooltip:'Description of uncertainty assessment method.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.5 Upload uncertainty calculation sheet',
          tooltip:'Supporting document for uncertainty estimation.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.6 Calibration certificates available?',
          tooltip:'Whether instruments used are calibrated.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.7 Upload calibration certificates',
          tooltip:'Calibration evidence (scales, analyzers, meters).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.8 External systems used for data capture?',
          tooltip:'Identify if digital sources or MES/PLC used.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.9 Source data systems (ERP/MES/SCADA)',
          tooltip:'Digital systems providing raw data.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.10 Upload system-generated raw data',
          tooltip:'Raw measurement dump (fuel, electricity, production).',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.2.11 Evidence of data QA/QC checks',
          tooltip:'Proof that data was validated internally.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: dataQualityLevelsKeys.DATA_QUALITY_LEVELS_QUESTION_6_2_11,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection6ThirdPartyVerificationTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '6.3.1 Has a third-party verifier reviewed this data?',
          tooltip:'Whether emissions data was externally verified.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.2 Verification body name',
          tooltip:'Name of accredited verification organisation.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.3 Verifier accreditation ID',
          tooltip:'Accreditation number or EU-recognised verifier ID.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.4 Country of verifier',
          tooltip:'Country of accredited verifier.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.5 Verification standard applied',
          tooltip:'Standard used for verification.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.6 Verification status',
          tooltip:'Result of verifier assessment.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.7 Upload verification statement',
          tooltip:'Final statement issued by verifier.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.8 Were any non-conformities raised?',
          tooltip:'Verifier NC reporting.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.9 Non-conformity description',
          tooltip:'Details of NC raised.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.10 Corrective actions taken',
          tooltip:'Steps taken by exporter to address NC.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '6.3.11 Upload corrective action evidence',
          tooltip:'Evidence supporting closure of NC.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: thirdPartyVerificationKeys.THIRD_PARTY_VERIFICATION_QUESTION_6_3_11,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection7ProductLevelEmissionSummaryTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '7.1.1 Select product',
          tooltip:'Product for which embedded emissions must be calculated.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.1.2 Total embedded emissions (tCO2)',
          tooltip:'Sum of direct + indirect + precursor emissions allocated to this product.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.1.3 Total product output (tons)',
          tooltip:'Quantity of product produced in the reporting period.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.1.4 Emission intensity (tCO2/ton product)',
          tooltip:'Final emission factor for the product.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.1.5 Method used for allocation',
          tooltip:'Allocation basis applied in distributing emissions to products.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.1.6 Precursor emissions included?',
          tooltip:'Whether internal/external clinker emissions included.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.1.7 Electricity emissions included?',
          tooltip:'Whether direct electricity EF included.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.1.8 Heat/steam emissions included?',
          tooltip:'Indicates whether thermal energy EF included.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.1.9 Total emissions excluded (if any)',
          tooltip:'Any emissions not included in CBAM calculation.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.1.10 Justification for excluded emissions',
          tooltip:'Explain any exclusions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: productLevelEmissionSummaryKeys.PRODUCT_LEVEL_EMISSION_SUMMARY_QUESTION_7_1_10,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection7ExportBatchEmissionAssignmentTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '7.2.1 Export batch number',
          tooltip:'Unique batch identifier used during shipment.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.2.2 Product shipped in this batch',
          tooltip:'Product linked to the batch.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.2.3 Batch quantity shipped (tons)',
          tooltip:'Total quantity of this product in batch.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.2.4 Shipment date',
          tooltip:'Shipment dispatch date.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.2.5 Export destination (EU country)',
          tooltip:'EU Member State where batch is imported.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.2.6 Emission intensity applied (tCO₂/ton)',
          tooltip:'Product emission intensity applied to this batch.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.2.7 Total embedded emissions in export batch (tCO₂)',
          tooltip:'Batch quantity × emission intensity.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.2.8 Transport emissions included?',
          tooltip:'Whether shipping/transport emissions included.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.2.9 EU importer EORI number',
          tooltip:'Importer\'s unique EU identifier.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.2.10 Upload export supporting documents',
          tooltip:'Invoices / B/L / Packing list.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: exportBatchEmissionAssignmentKeys.EXPORT_BATCH_EMISSION_ASSIGNMENT_QUESTION_7_2_10,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];

  export const cbamSection7DocumentAttachmentsTabQuestions=[
    {
      key: '1',
      items: [
        {
          question: '7.3.1 Upload consolidated emission calculation sheet',
          tooltip:'Full calculation workbook of embedded emissions.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_1,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.2 Upload raw data logs',
          tooltip:'All activity data: fuel, electricity, clinker, SCM.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_2,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.3 Upload system boundary diagram',
          tooltip:'Flow diagram showing processes included/excluded.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_3,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.4 Upload uncertainty assessment',
          tooltip:'Document showing uncertainty analysis.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_4,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.5 Upload verifier report (if applicable)',
          tooltip:'External verification statement.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_5,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.6 Upload corrective actions taken (if any NC)',
          tooltip:'Evidence of NC closure.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_6,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.7 Upload CBAM-specific documents',
          tooltip:'Optional additional material for importer.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_7,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.8 CBAM Report Sign-off (Digital)',
          tooltip:'Declaration that data is accurate & complete.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_8,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.9 Sign-off authority name',
          tooltip:'Person signing the CBAM declaration.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_9,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.10 Sign-off authority designation',
          tooltip:'Title of responsible person.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_10,
              fieldLabel: ''
            }
          ]
        },
        {
          question: '7.3.11 Sign-off date',
          tooltip:'Date CBAM package approved internally.',
          field: [
            {
              fieldType: inputType.TEXT,
              fieldName: documentAttachmentsKeys.DOCUMENT_ATTACHMENTS_QUESTION_7_3_11,
              fieldLabel: ''
            }
          ]
        }
      ]
    }
  ];